import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f310d37a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-5" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "total" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, [
  /*#__PURE__*/_createTextVNode("kg CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("e")
], -1))
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "total" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "€", -1))
const _hoisted_10 = {
  key: 0,
  class: "col-sm-3"
}
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "total" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "€", -1))
const _hoisted_15 = {
  key: 1,
  class: "col-sm-2"
}
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "total" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "€", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Summary")
], -1))
const _hoisted_21 = { class: "table" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Bag type"),
    /*#__PURE__*/_createElementVNode("th", null, "Main Body Material"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Weight")
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Composition")
], -1))
const _hoisted_24 = { class: "table" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Material"),
    /*#__PURE__*/_createElementVNode("th", null, "Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Percentage"),
    /*#__PURE__*/_createElementVNode("th", null, "CO2e")
  ])
], -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 4 }
const _hoisted_35 = { key: 5 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_42 = { class: "d-flex align-items-center justify-content-between mt-5" }
const _hoisted_43 = { class: "table" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Phase"),
    /*#__PURE__*/_createElementVNode("th", null, "Origin Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Destination Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Transport Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Transport CO2e Grams")
  ])
], -1))
const _hoisted_45 = {
  key: 0,
  class: "fs-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.model.providerPrice > 0 ? 'col-sm-3' : 'col-sm-6')
      }, [
        _createElementVNode("p", _hoisted_2, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Total",
            text: "Total"
          })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Footprint",
            text: "Footprint"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.approximation(_ctx.model.totalCO2e)), 1),
          _hoisted_5
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.model.providerPrice > 0 ? 'col-sm-4' : 'col-sm-6')
      }, [
        _createElementVNode("p", _hoisted_6, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Estimated Offsetting",
            text: "Estimated Offsetting"
          })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Cost In EUR",
            text: "Cost In EUR"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.model.totalSuggestedCost), 1),
          _hoisted_9
        ])
      ], 2),
      (_ctx.model.providerPrice > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Provider",
                text: "Provider"
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Price",
                text: "Price"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.model.providerPrice), 1),
              _hoisted_14
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.model.providerPrice > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Total",
                text: "Total"
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Price",
                text: "Price"
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$filters.currency(_ctx.model.totalPrice)), 1),
              _hoisted_19
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_20,
    _createElementVNode("table", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.model.bestBagEstimation.bagData.bagType), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.model.bestBagEstimation.bagData.mainMaterial), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(_ctx.model.bestBagEstimation.bagData.selectedComposition.totalWeight, 2)) + "gr", 1)
        ])
      ])
    ]),
    _hoisted_23,
    _createElementVNode("table", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCompositionFormattedData, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.name
          }, [
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(item.parentName), 1))
              : _createCommentVNode("", true),
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(item.name), 1))
              : _createCommentVNode("", true),
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                  (item.materialsSummaryText)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.materialsSummaryText), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, "-- none"))
                ]))
              : _createCommentVNode("", true),
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                  (item.selectedCountry.text)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.selectedCountry.text), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_33, "-- none"))
                ]))
              : _createCommentVNode("", true),
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(item.percentage) + "%", 1))
              : _createCommentVNode("", true),
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(_ctx.$filters.approximation(item.getCo2eEmissions)), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.bestBagEstimation.bagData.selectedComposition.sangleValues, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.name
          }, [
            (item.parentName)
              ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(item.parentName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, _toDisplayString(item.name), 1),
            _createElementVNode("td", null, [
              (item.materialsSummaryText)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.materialsSummaryText), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_38, "-- none"))
            ]),
            _createElementVNode("td", null, [
              (item.selectedCountry.text)
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.selectedCountry.text), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_40, "-- none"))
            ]),
            _hoisted_41,
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(item.getCo2eEmissions)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("p", _hoisted_42, [
      _createVNode(_component_localized_text, {
        type: "strong",
        localizedKey: "Process Locations and Transportation",
        text: "Process Locations and Transportation"
      }),
      (_ctx.model.provider && _ctx.model.provider.text)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            type: "strong",
            localizedKey: "See details",
            text: "See details",
            class: "text-decoration-underline pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDetailModal()))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("table", _hoisted_43, [
      _hoisted_44,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.bestBagEstimation.bagData.processesCo2eEmissionsAndTransports, (procTr, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(procTr.transportProductionPhase.productionPhase), 1),
            _createElementVNode("td", null, _toDisplayString(procTr.transportProductionPhase.countryOfOrigin), 1),
            _createElementVNode("td", null, _toDisplayString(procTr.transportProductionPhase.countryOfDestination), 1),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procTr.transportProductionPhase.transportTypes, (type, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fs-12 mb-1",
                  key: j
                }, _toDisplayString(type.transportType) + " - " + _toDisplayString(_ctx.$filters.approximation(type.transportCO2)), 1))
              }), 128)),
              (procTr.transportProductionPhase.transportTypes.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45, "---"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(procTr.transportProductionPhase.transportCO2)), 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}